interface _FileDocument {
    code: string,
    file: string,
    binary: string,
    data: any  
}

class FileDocument implements _FileDocument {
    code: string
    file: string
    binary: string
    data: any  

    constructor() {
        this.code = '';
        this.file = '';
        this.binary = '';
        this.data = null;
    }
}

interface _CambioPropietario {
    id: number | string
    new_contribuyente_id: number | null
    old_contribuyente_id: number | null
    has_alcohol: boolean
    renovacion: number
    has_licencia_bebidas: boolean
    patente_propia: boolean
    folio_licencia_bebida_alcoholica: string
    tiene_uso_suelo: boolean
    old_rfc: string
    new_rfc: string
    tipo_propiedad_id: number | null
    tipo_proceso_id: number | null
    superficie: number
    documentos: {
        scap_saneamiento: FileDocument
        scap_licencia: FileDocument
        scap_pago_licencia_bebidas: FileDocument
        scap_licencia_comodato: FileDocument
        aviso_cierre: FileDocument
        aviso_apertura: FileDocument
        constancia_us_cap: FileDocument
    }
    predial: {
        //Documentos para predial
        titulo_escritura: FileDocument
        arrendamiento_contrato: FileDocument
        arrendamiento_identificacion: FileDocument
        arrendador_identificacion: FileDocument
        arrendamiento_testigos: FileDocument
        licencia_construccion: FileDocument
    }
    fotos: {
        frente: FileDocument,
        interior: FileDocument,
        wc: FileDocument,
        lateralIzquierdo: FileDocument,
        lateralDerecho: FileDocument
    }
}

export class CambioPropietario implements _CambioPropietario {
    id = ''
    new_contribuyente_id = null
    old_contribuyente_id = null
    renovacion = 0
    has_alcohol = false
    has_licencia_bebidas = true
    patente_propia = true
    folio_licencia_bebida_alcoholica = ''
    tiene_uso_suelo = false
    old_rfc = ''
    new_rfc = ''
    tipo_propiedad_id = null
    tipo_proceso_id = null
    superficie = 0
    documentos: any = {
        scap_saneamiento: new FileDocument(),
        scap_licencia: new FileDocument(),
        scap_pago_licencia_bebidas: new FileDocument(),
        scap_licencia_comodato: new FileDocument(),
        aviso_cierre: new FileDocument(),
        aviso_apertura: new FileDocument(),
        constancia_us_cap: new FileDocument(),
    }
    predial: any = {
        //Documentos para predial
        titulo_escritura: new FileDocument(),
        arrendamiento_contrato: new FileDocument(),
        arrendamiento_identificacion: new FileDocument(),
        arrendador_identificacion: new FileDocument(),
        arrendamiento_testigos: new FileDocument(),
        licencia_construccion: new FileDocument()
    }
    fotos: any = {
        frente: new FileDocument(),
        interior: new FileDocument(),
        wc: new FileDocument(),
        lateralIzquierdo: new FileDocument(),
        lateralDerecho: new FileDocument()
    }
}